import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n/i18n'

// Console filter to hide all .woff/.ttf font errors and other noisy patterns
(function() {
  const originalError = console.error;
  const originalWarn = console.warn;
  const noisyPatterns = [
    'office.net',
    'wordviewer.css',
    'wordviewerds.js',
    'Unsafe attempt to initiate navigation for frame with origin',
    'allow-top-navigation',
  ];
  const fontRegex = /\.woff2?|\.ttf/i;
  function isNoisy(msg) {
    return fontRegex.test(msg) || noisyPatterns.some(pattern => msg.includes(pattern));
  }
  console.error = function(...args) {
    const msg = args.join(' ');
    if (isNoisy(msg)) return;
    originalError.apply(console, args);
  };
  console.warn = function(...args) {
    const msg = args.join(' ');
    if (isNoisy(msg)) return;
    originalWarn.apply(console, args);
  };
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
